var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEnforce2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2051_1040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99999C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20.2497C24 21.5977 23.3211 22.855 22.1939 23.5943L14.5461 28.611C13.2531 29.4592 11.587 29.4861 10.2673 28.6801L1.91517 23.5793C0.7256 22.8528 0 21.5594 0 20.1655V3.99999Z",
    fill: "url(#paint0_linear_2051_1040)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54163 15.72H6.20563V13.352H3.88563V11.144H6.20563V8.808H8.54163V11.144H10.8616V13.352H8.54163V15.72ZM18.3198 6.28V11.752L14.0318 14.952V17.352L18.3198 17.336V19.56H11.6318V13.864L15.9038 10.664V7.624L15.6318 7.336H14.3038L14.0318 7.624V9.576H11.6318V6.28L12.7678 5.128H17.1678L18.3198 6.28Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2051_1040",
    x: -1,
    y: -1,
    width: 25,
    height: 30.2666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2051_1040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2051_1040",
    x1: 3.24888e-7,
    y1: 0.428571,
    x2: 24,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#634F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#251E18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEnforce2);
export default __webpack_public_path__ + "static/media/ic_enforce_2.4f135517ac9dc1fdaf935da0a20220dc.svg";
export { ForwardRef as ReactComponent };